export function getInitials(name: string) {
  const initials = name
    .split(" ")
    .map((word) => word.charAt(0))
    .slice(0, 2)
    .join("");
  return initials.toUpperCase();
}

/*
A0  841x1189
A1  594x841
A2  420x594
A3  297x420
A4  210x297
A5  148x210
A6  105x148
A7  74x105 
A8  52x74
A9  37x52
A10 26x37

*/
export function getDinFormatFromSize(dimensions: string): string {
  const parsedDimensions = dimensions.trim().replaceAll(" ", "").toLowerCase();
  if (parsedDimensions === "841x1189" || parsedDimensions === "1189x841")
    return "A0";
  if (parsedDimensions === "594x841" || parsedDimensions === "841x594")
    return "A1";
  if (parsedDimensions === "420x594" || parsedDimensions === "594x420")
    return "A2";
  if (parsedDimensions === "297x420" || parsedDimensions === "420x297")
    return "A3";
  if (parsedDimensions === "210x297" || parsedDimensions === "297x210")
    return "A4";
  if (parsedDimensions === "148x210" || parsedDimensions === "210x148")
    return "A5";
  if (parsedDimensions === "105x148" || parsedDimensions === "148x105")
    return "A6";
  if (parsedDimensions === "74x105 " || parsedDimensions === "105x74")
    return "A7";
  if (parsedDimensions === "52x74" || parsedDimensions === "74x52") return "A8";
  if (parsedDimensions === "37x52" || parsedDimensions === "52x37") return "A9";
  if (parsedDimensions === "26x37" || parsedDimensions === "37x26")
    return "A10";

  return "";
}
